function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_970",
  "data-name": "Group 970",
  transform: "translate(-271.223 -10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_967",
  "data-name": "Group 967"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_47",
  "data-name": "Ellipse 47",
  transform: "translate(292.723 34) rotate(180)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_55",
  "data-name": "Line 55",
  x2: 12,
  transform: "translate(284.223 29.5) rotate(180)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_56",
  "data-name": "Line 56",
  x2: 4,
  transform: "translate(296.223 29.5) rotate(180)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_968",
  "data-name": "Group 968",
  transform: "translate(568.445 44) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_47-2",
  "data-name": "Ellipse 47",
  transform: "translate(292.723 34) rotate(180)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 4.5,
  r: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_55-2",
  "data-name": "Line 55",
  x2: 12,
  transform: "translate(284.223 29.5) rotate(180)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_56-2",
  "data-name": "Line 56",
  x2: 4,
  transform: "translate(296.223 29.5) rotate(180)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
})));

var SvgFilters = function SvgFilters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filters.2d8d1495.svg";
export { ForwardRef as ReactComponent };